import MicroChip from "./MicroChip";

import "./microChipList.scss"

interface IMicroChipList{
  title: string;
  data: ILanguagesToTeach[]
}

interface ILanguagesToTeach{
    language: string;
    proficiency: string;
}

export default function MicroChipList({title, data}:IMicroChipList){
    return(
        <div className="chip-info-wrapper">

          <div className="text-pad-left">{title} </div>
            <div className="chip-wrapper">
            
             {data.map(langToTeach => (
             <MicroChip data={langToTeach} />
               ))}
              
            </div>
        </div>
    )
}